import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CacConsultComponent } from './cac-consult/cac-consult.component';
import { AuthGuard } from 'src/app/guards/auth.guard';

const routesCac: Routes = [
    { path: 'cac-consult', component: CacConsultComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(routesCac)],
    exports: [RouterModule],
})
export class CacRoutingModule { }
